import { BUTTON_DISABLED_TEXT, HEFFALUMP } from 'HubStyleTokens/colors';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
// @TODO: DELETE ME once all consumers have migrated to `TextToolbarIcon`
const UITextToolbarIcon = styled(UIIcon).attrs({
  size: 14
}).withConfig({
  displayName: "UITextToolbarIcon",
  componentId: "sc-1t85o8l-0"
})(["color:", ";"], ({
  disabled
}) => disabled ? BUTTON_DISABLED_TEXT : HEFFALUMP);
UITextToolbarIcon.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired
};
UITextToolbarIcon.displayName = 'UITextToolbarIcon';
export default UITextToolbarIcon;